import { render, staticRenderFns } from "./EditInPlace.vue?vue&type=template&id=636767f0&"
import script from "./EditInPlace.vue?vue&type=script&lang=js&"
export * from "./EditInPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports